// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/ContextMenuTextAlignRow/index.tsx

import { Flex } from '@modusign/design-system';
import { TextAlign } from '@modusign/react-signing/types';

import TextAlignButton from './TextAlignButton';

interface ContextMenuTextAlignRowProps {
  selectedTextAlign: TextAlign;
  onChange: (textAlign: TextAlign) => void;
}

const defaultProps = {
  selectedTextAlign: 'LEFT',
  onChange(_textAlign: TextAlign) {},
};

function ContextMenuTextAlignRow({ selectedTextAlign, onChange }: ContextMenuTextAlignRowProps) {
  function handleChange(textAlign: TextAlign) {
    if (selectedTextAlign !== textAlign) {
      onChange(textAlign);
    }
  }

  return (
    <Flex alignItems="center" height="32px" justifyContent="space-between" position="relative">
      <b>정렬</b>
      <Flex gap={2}>
        <TextAlignButton
          selected={selectedTextAlign === 'LEFT'}
          textAlign={'LEFT'}
          onClick={handleChange}
        />
        <TextAlignButton
          selected={selectedTextAlign === 'CENTER'}
          textAlign={'CENTER'}
          onClick={handleChange}
        />
        <TextAlignButton
          selected={selectedTextAlign === 'RIGHT'}
          textAlign={'RIGHT'}
          onClick={handleChange}
        />
      </Flex>
    </Flex>
  );
}

ContextMenuTextAlignRow.defaultProps = defaultProps;

export default ContextMenuTextAlignRow;
